import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/HomePage.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/LoginPage.vue'),
      meta: { guestOnly: true }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/RegisterPage.vue'),
      meta: { guestOnly: true }
    },
    {
      path: '/mfa-challenge',
      name: 'mfa-challenge',
      component: () => import('@/pages/MfaChallengePage.vue'),
      meta: { guestOnly: true }
    },
    {
      path: '/dashboard',
      component: () => import('@/layouts/DashboardLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'dashboard',
          component: () => import('@/pages/dashboard/DashboardHome.vue')
        },
        {
          path: 'reports',
          name: 'reports',
          component: () => import('@/pages/dashboard/ReportsPage.vue')
        },
        {
          path: 'reports/new',
          name: 'new-report',
          component: () => import('@/pages/dashboard/NewReportPage.vue')
        },
        {
          path: 'reports/:id',
          name: 'report-builder',
          component: () => import('@/pages/dashboard/ReportBuilderPage.vue')
        },
        {
          path: 'reports/:id/view',
          name: 'report-view',
          component: () => import('@/pages/dashboard/ProtestReportPage.vue')
        },
        {
          path: 'alerts',
          name: 'alerts',
          component: () => import('@/pages/dashboard/AlertsPage.vue')
        },
        {
          path: 'settings',
          name: 'settings',
          component: () => import('@/pages/dashboard/SettingsPage.vue')
        }
      ]
    },
    {
      path: '/unsubscribe/:token',
      name: 'unsubscribe',
      component: () => import('@/pages/UnsubscribePage.vue')
    },
    {
      path: '/property/:accountNum',
      name: 'property',
      component: () => import('@/pages/PropertyPage.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/pages/NotFoundPage.vue')
    }
  ]
})

// Handle stale chunk errors after deployments (dynamic import fails when old hashes are gone)
router.onError((error, to) => {
  if (
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed')
  ) {
    // Full page reload to pick up new chunk manifest
    window.location.href = to.fullPath
  }
})

// Navigation guards
router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  // Wait for auth check to complete if not yet done
  if (!authStore.initialized) {
    await authStore.checkAuth()
  }

  // Redirect authenticated users away from guest-only pages
  if (to.meta.guestOnly && authStore.isAuthenticated) {
    return next({ name: 'dashboard' })
  }

  // Redirect unauthenticated users away from protected pages
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return next({ name: 'login', query: { redirect: to.fullPath } })
  }

  next()
})

export default router
